/**
 * checkIfProductInstanceIsInCart
 *
 * @param {Number} productInstanceId - id to check against
 * @param {Array} carts - list of cart objects
 * @return {Object} existingCartProduct
 */
const checkIfProductInstanceIsInCart = ({ productInstanceId, carts=[], subscriptionTypeTermId }) => {
	for (let cartIndex = 0; cartIndex < carts.length; cartIndex++) {
		let cart = carts[cartIndex];
		for (var cpIndex = 0; cpIndex < cart.products.length; cpIndex++) {
			let cartProduct = cart.products[cpIndex];
			if (cartProduct.productInstanceId === productInstanceId) {
				if (!subscriptionTypeTermId || cartProduct?.subscriptionTypeTermId === subscriptionTypeTermId) {
					return {
						cartId: cart.id,
						...cartProduct,
					};
				}
			}
		}
	}
	return false;
};

/**
 * Return cartId if productId is in cart
 *
 * @param {Number} productId
 * @param {Array} carts - of cart objects
 * @return {Bool or Integer} cartId or false
 */
export const checkIfProductInCart = (productId, carts=[]) => {
	for (let cartIndex = 0; cartIndex < carts.length; cartIndex++) {
		let cart = carts[cartIndex];
		for (var cpIndex = 0; cpIndex < cart.products.length; cpIndex++) {
			let cartProduct = cart.products[cpIndex];
			if (cartProduct.productInstance?.product?.id === productId) {
				return cart.id;
			}
		}
	}
	return false;
};

export default checkIfProductInstanceIsInCart;
